import styled from '@emotion/styled/macro';

export const Wrapper = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;
